import { withImageOptimizationQuery } from '@common/utils';
import { useCatalogProductIdParams, usePdpBaseInfo } from '@domains/pdp-common';

export const useFistOrderBannerService = () => {
  const params = useCatalogProductIdParams();
  const {
    product: {
      product_price: { first_order_discount },
    },
  } = usePdpBaseInfo(params);

  return {
    guidance_image_url:
      withImageOptimizationQuery(first_order_discount?.guidance_image_url, { format: 'webp', quality: 80 }) ??
      first_order_discount?.guidance_image_url ??
      '',
    isHide: !first_order_discount?.guidance_image_url,
  };
};
